"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInputWithLocation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var firestore_1 = require("firebase/firestore");
var react_1 = require("react");
var AddressInputWithLocation = function (_a) {
    var label = _a.label, value = _a.value, placeholder = _a.placeholder, errorText = _a.errorText, onChange = _a.onChange, onLocationSelect = _a.onLocationSelect, _b = _a.primaryColor, primaryColor = _b === void 0 ? "#dc2626" : _b;
    var _c = (0, react_1.useState)(false), showDropdown = _c[0], setShowDropdown = _c[1];
    var _d = (0, react_1.useState)([]), searchResults = _d[0], setSearchResults = _d[1];
    var _e = (0, react_1.useState)(false), isSearching = _e[0], setIsSearching = _e[1];
    var _f = (0, react_1.useState)(value || ""), searchValue = _f[0], setSearchValue = _f[1];
    var _g = (0, react_1.useState)(null), googleMapsError = _g[0], setGoogleMapsError = _g[1];
    var _h = (0, react_1.useState)(false), hasSelectedAddress = _h[0], setHasSelectedAddress = _h[1];
    var dropdownRef = (0, react_1.useRef)(null);
    var inputContainerRef = (0, react_1.useRef)(null);
    var debounceTimerRef = (0, react_1.useRef)(null);
    var autocompleteServiceRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        setSearchValue(value);
    }, [value]);
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            if (inputContainerRef.current &&
                !inputContainerRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Initialize Google Places services when available
    (0, react_1.useEffect)(function () {
        var initGoogleServices = function () {
            var _a, _b;
            if ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) {
                if (!autocompleteServiceRef.current) {
                    autocompleteServiceRef.current =
                        new window.google.maps.places.AutocompleteService();
                }
                // Note: We avoid creating a Map instance as it requires Maps JavaScript API
                // Instead, we'll use Geocoder for coordinates or the new Place class
                setGoogleMapsError(null);
            }
        };
        // Try immediately
        initGoogleServices();
        // Also check periodically in case Google Maps loads later
        var interval = setInterval(function () {
            var _a, _b;
            if ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) {
                initGoogleServices();
                clearInterval(interval);
            }
        }, 500);
        return function () { return clearInterval(interval); };
    }, []);
    var handleLocationSearch = (0, react_1.useCallback)(function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var request;
        var _a, _b;
        return __generator(this, function (_c) {
            if (!query || query.length < 3) {
                setSearchResults([]);
                setShowDropdown(false);
                return [2 /*return*/];
            }
            setIsSearching(true);
            setShowDropdown(true);
            setGoogleMapsError(null);
            try {
                // Check if Google Maps is available
                if (!((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) || !autocompleteServiceRef.current) {
                    setGoogleMapsError("Google Maps not loaded. Please refresh the page.");
                    setSearchResults([]);
                    setIsSearching(false);
                    return [2 /*return*/];
                }
                request = {
                    input: query,
                    // Restrict to Namibia and Botswana
                    componentRestrictions: { country: ["na", "bw"] },
                };
                autocompleteServiceRef.current.getPlacePredictions(request, function (predictions, status) {
                    setIsSearching(false);
                    if (status === google.maps.places.PlacesServiceStatus.OK &&
                        predictions) {
                        var results = predictions.map(function (prediction) { return ({
                            description: prediction.description,
                            place_id: prediction.place_id,
                            structured_formatting: {
                                main_text: prediction.structured_formatting.main_text,
                                secondary_text: prediction.structured_formatting.secondary_text || "",
                            },
                        }); });
                        setSearchResults(results);
                    }
                    else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                        setSearchResults([]);
                    }
                    else {
                        console.error("Places autocomplete error:", status);
                        setGoogleMapsError("Address search temporarily unavailable");
                        setSearchResults([]);
                    }
                });
            }
            catch (error) {
                console.error("Address search error:", error);
                setSearchResults([]);
                setIsSearching(false);
            }
            return [2 /*return*/];
        });
    }); }, []);
    // Debounced search - triggers automatically as user types
    var handleInputChange = (0, react_1.useCallback)(function (newValue) {
        setSearchValue(newValue);
        onChange(newValue);
        setHasSelectedAddress(false);
        // Clear previous timer
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        // Don't search if value is too short
        if (newValue.length < 3) {
            setSearchResults([]);
            setShowDropdown(false);
            return;
        }
        // Debounce the search (300ms delay)
        debounceTimerRef.current = setTimeout(function () {
            handleLocationSearch(newValue);
        }, 300);
    }, [onChange, handleLocationSearch]);
    // Cleanup debounce timer on unmount
    (0, react_1.useEffect)(function () {
        return function () {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);
    var handleSelectAddress = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var Place, place, lat, lng, geoPoint, placeError_1, geocoder, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    // Update the displayed address immediately
                    onChange(address.description);
                    setSearchValue(address.description);
                    setShowDropdown(false);
                    setSearchResults([]);
                    setHasSelectedAddress(true);
                    if (!onLocationSelect) return [3 /*break*/, 7];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 6, , 7]);
                    if (!(((_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.Place) && address.place_id)) return [3 /*break*/, 5];
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 4, , 5]);
                    Place = window.google.maps.places.Place;
                    place = new Place({ id: address.place_id });
                    return [4 /*yield*/, place.fetchFields({ fields: ["location"] })];
                case 3:
                    _f.sent();
                    if (place.location) {
                        lat = place.location.lat();
                        lng = place.location.lng();
                        geoPoint = new firestore_1.GeoPoint(lat, lng);
                        onLocationSelect(address.description, geoPoint);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    placeError_1 = _f.sent();
                    console.warn("Place API failed, trying Geocoder:", placeError_1);
                    return [3 /*break*/, 5];
                case 5:
                    // Fallback to Geocoder (doesn't require Maps JavaScript API to be enabled)
                    if ((_e = (_d = window.google) === null || _d === void 0 ? void 0 : _d.maps) === null || _e === void 0 ? void 0 : _e.Geocoder) {
                        geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ address: address.description }, function (results, status) {
                            var _a, _b;
                            if (status === google.maps.GeocoderStatus.OK &&
                                results &&
                                ((_b = (_a = results[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.location)) {
                                var lat = results[0].geometry.location.lat();
                                var lng = results[0].geometry.location.lng();
                                var geoPoint = new firestore_1.GeoPoint(lat, lng);
                                onLocationSelect(address.description, geoPoint);
                            }
                            else {
                                console.warn("Geocoder failed:", status);
                                onLocationSelect(address.description, null);
                            }
                        });
                    }
                    else {
                        // No geocoding available, just return the address without coordinates
                        onLocationSelect(address.description, null);
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _f.sent();
                    console.error("Error getting coordinates:", error_1);
                    onLocationSelect(address.description, null);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "relative", ref: inputContainerRef, children: [(0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: label, value: searchValue, size: "small", errorText: errorText, textColor: "text-gray-900", borderColor: "border-gray-300", backgroundColor: "bg-white", onChange: handleInputChange }), (0, jsx_runtime_1.jsx)("div", { className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none", style: { marginTop: errorText ? "-10px" : "0" }, children: isSearching ? ((0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-4 w-4 border-2 border-t-transparent", style: { borderColor: primaryColor, borderTopColor: "transparent" } })) : hasSelectedAddress ? ((0, jsx_runtime_1.jsx)("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: primaryColor, xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }) })) : ((0, jsx_runtime_1.jsx)("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "#9CA3AF", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" }) })) })] }), showDropdown && (searchResults.length > 0 || isSearching || googleMapsError) && ((0, jsx_runtime_1.jsx)("div", { ref: dropdownRef, className: "absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto", children: isSearching ? ((0, jsx_runtime_1.jsx)("div", { className: "p-3 text-center text-gray-500", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center gap-2", children: [(0, jsx_runtime_1.jsx)("div", { className: "animate-spin rounded-full h-4 w-4 border-2 border-t-transparent", style: { borderColor: primaryColor, borderTopColor: "transparent" } }), "Searching addresses..."] }) })) : googleMapsError ? ((0, jsx_runtime_1.jsx)("div", { className: "p-3 text-center text-red-500", children: googleMapsError })) : (searchResults.map(function (address, index) {
                    var _a, _b;
                    return ((0, jsx_runtime_1.jsxs)("div", { className: "p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 flex items-start gap-2", onClick: function () { return handleSelectAddress(address); }, children: [(0, jsx_runtime_1.jsx)("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: primaryColor, className: "mt-0.5 flex-shrink-0", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 min-w-0", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-sm text-gray-800 font-medium truncate", children: ((_a = address.structured_formatting) === null || _a === void 0 ? void 0 : _a.main_text) ||
                                            address.description }), ((_b = address.structured_formatting) === null || _b === void 0 ? void 0 : _b.secondary_text) && ((0, jsx_runtime_1.jsx)("div", { className: "text-xs text-gray-500 mt-0.5 truncate", children: address.structured_formatting.secondary_text }))] })] }, address.place_id || index));
                })) }))] }));
};
exports.AddressInputWithLocation = AddressInputWithLocation;
